<template>
  <div class="tw-mx-4 tw-py-4">
    <div class="tw-grid tw-grid-cols-10 tw-gap-5">
      <div class="tw-col-span-2 tw-space-y-3">
        <GameSearchFilters></GameSearchFilters>
      </div>
      <div class="tw-space-y-3 tw-col-span-8">
        <CasinoTabs :casinoProviders="casinoProviders" @onGoToCasino="goToCasino"></CasinoTabs>
        <div class="tw-w-full tw-flex tw-justify-between tw-mb-5">
          <GameSearch
            @onSearchText="search = $event"
            @search="searchData(null, true)"
            :showNavLabel="false"
          ></GameSearch>
          <div class="tw-flex tw-items-center tw-space-x-3">
            <v-select
              class="tw-w-48"
              color="#C2C2C2"
              item-color="#C2C2C2"
              v-model="selected_provider"
              :items="provider"
              label="Provider"
              hide-details
              dark
              outlined
              dense
              rounded
            ></v-select>
            <v-select
              class="tw-w-48"
              color="#C2C2C2"
              item-color="#C2C2C2"
              v-model="filtered_item"
              :items="filter"
              label="Game Type"
              hide-details
              dark
              dense
              outlined
              rounded
            ></v-select>
          </div>
        </div>

        <div class="grid-games" v-if="!loading">
          <div v-for="(game, i) in gameDetailsList" :key="i">
            <GameCard :cgame="game" @onSave="onSave"></GameCard>
          </div>
        </div>
        <v-pagination
          color="#3c64fb"
          v-model="curPage"
          :length="numberOfPages"
          :total-visible="7"
          @input="setCurrentPage"
          circle
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import GameSearchFilters from "../../components/GameSearchFilters.vue";
import GameSearch from "../../components/GameSearch.vue";
import GameCard from "../../components/admin/GameCard.vue";
import CasinoTabs from "../../components/admin/CasinoTabs.vue";
export default {
  props: ["casinoProviders"],
  components: {
    GameSearchFilters,
    GameSearch,
    GameCard,
    CasinoTabs,
  },
  data: () => ({
    filter: [],
    provider: [],
    filtered_item: "",
    selected_provider: "",
    searchTime: null,
    curPage: 1,
    pageCount: 0,
    pageSize: 0,
    itemsPerPage: 50,
    totalItems: 0,
    search: "",
    loading: false,
    gameDetailsList: [],
  }),
  async mounted() {
    this.loading = true;
    if (this.$route.query.page != null && this.curPage != parseInt(this.$route.query.page)) {
      this.curPage = parseInt(this.$route.query.page) || 1;
    }
    if (this.$route.query.q != null && this.search != this.$route.query.q) {
      this.search = this.$route.query.q || null;
    }
    if (this.$route.query.type != null) {
      this.filtered_item = this.$route.query.type || null;
    }
    if (this.$route.query.provider != null) {
      this.selected_provider = this.$route.query.provider || null;
      await this.getGameTypesByProvider();
    } else {
      await this.getGameType();
    }
    await this.getProvider();
    await this.searchData();
    await this.validateGames();
    this.loading = false;
  },
  computed: {
    ...mapState("game", ["adminGames"]),
    numberOfPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  watch: {
    async search() {
      this.curPage = 1;
      this.replaceUrl();
      if (this.searchTime) {
        clearTimeout(this.searchTime);
        this.searchTime = null;
      }
      this.searchTime = setTimeout(async () => {
        await this.searchData();
        await this.validateGames();
        clearTimeout(this.searchTime);
      }, 500);
    },
    async curPage() {
      await this.$router.push({
        path: "/admin/casino-games",
        query: { ...this.$route.query, page: this.curPage },
      });
      await this.searchData();
      await this.validateGames();
    },
    async filtered_item() {
      this.curPage = 1;
      let check = this.filtered_item;
      console.log(this.filtered_item);
      if (check == "All") {
        check = "";
      }
      await this.$router.push({
        path: "/admin/casino-games",
        query: { ...this.$route.query, type: check },
      });
      await this.filterData();
      await this.validateGames();
    },
    async selected_provider() {
      this.curPage = 1;
      let check = this.selected_provider;
      if (check == "All" || check == null) {
        check = "";
      }
      await this.$router.push({
        path: "/admin/casino-games",
        query: { ...this.$route.query, provider: check },
      });
      if (check == "") {
        await this.getGameType();
      } else {
        await this.getGameTypesByProvider();
      }
      if (!this.filter.includes(this.$route.query.type)) {
        this.$router.push({
          path: "/admin/casino-games",
          query: { ...this.$route.query, type: null },
        });
      }

      await this.filterData();
      await this.validateGames();
    },
  },
  methods: {
    ...mapActions("game", [
      "saveGameToDb",
      "removeGameToDb",
      "getGamesSaved",
      "getGameDetails",
      "searchGameDetail",
      "filterGames",
      "filterGameTypes",
      "adminFilterProviders",
      "filterGameTypesByProvider",
    ]),
    ...mapMutations("game", ["setAdminGames"]),

    onSave({ add, payload, game_type }) {
      if (add) {
        this.gameDetailsList = this.gameDetailsList.map((game) => {
          if (game.uuid == payload.uuid) {
            game.game_type = game_type;
            game.saved = true;
          }
          return game;
        });
      } else {
        this.gameDetailsList = this.gameDetailsList.map((game) => {
          if (game.uuid == payload.uuid) {
            delete game.saved;
          }
          return game;
        });
      }
    },

    async validateGames() {
      const savedGames = await this.getGamesSaved(this.gameDetailsList.map((game) => game.uuid));
      this.gameDetailsList = this.gameDetailsList.map((game) => {
        const saved = savedGames.find((saved) => saved.uuid == game.uuid);
        if (saved) {
          game.game_type = saved.game_type;
          game.saved = true;
        }
        return game;
      });
    },
    replaceUrl() {
      if (this.search != this.$route.query.q) {
        let query = {
          ...this.$route.query,
          q: this.search,
        };
        this.$router.replace({
          query,
        });
      }
    },
    goToCasino(provider) {
      if (provider == "Casino Games") {
        return this.$router.push("/admin/casino-games");
      }
      this.$router.push({
        path: "/admin/games",
        query: { casinoprovider: provider },
      });
    },

    async gameDetails(item) {
      if (item) this.itemsPerPage = item;
      this.gameDetailsList = [];
      const res = await this.getGameDetails({
        page: this.curPage,
        pageSize: item ? item : this.itemsPerPage,
      });
      this.totalItems = res.count;
      this.gameDetailsList = res.rows;
      console.log("gameDetailsList", this.gameDetailsList);
    },
    async setCurrentPage(page) {
      this.curPage = page;
      this.$router.push({
        path: "/admin/casino-games",
        query: { ...this.$route.query, page },
      });
      await this.searchData();
      await this.validateGames();
    },
    async searchData(item, search = false) {
      if (search) this.curPage = 1;
      const res = await this.searchGameDetail({
        page: this.curPage,
        pageSize: item ? item : this.itemsPerPage,
        search: this.$route.query.q,
        provider: this.$route.query.provider,
        type: this.$route.query.type,
      });
      this.gameDetailsList = [];
      this.totalItems = res.count;
      this.gameDetailsList = res.rows;
      await this.validateGames();
      console.log("games", res);
    },
    async filterData(item) {
      const res = await this.filterGames({
        page: this.curPage,
        pageSize: item ? item : this.itemsPerPage,
        search: this.$route.query.q,
        provider: this.$route.query.provider,
        type: this.$route.query.type,
      });
      this.gameDetailsList = [];
      this.totalItems = res.count;
      this.gameDetailsList = res.rows;
      await this.validateGames();
      console.log("filterData", res);
    },
    async getGameType() {
      this.filter.push("All");
      const type = await this.filterGameTypes();
      type.map((obj) => {
        let capitalized = obj.type.replace(/^./, obj.type[0].toUpperCase());
        this.filter.push(capitalized);
      });
    },
    async getProvider() {
      this.provider.push("All");
      const provider = await this.adminFilterProviders();
      provider.map((obj) => {
        let capitalized = obj.provider.replace(/^./, obj.provider[0].toUpperCase());
        this.provider.push(capitalized);
      });
    },
    async getGameTypesByProvider() {
      let data = {
        provider: this.$route.query.provider,
      };
      const types = await this.filterGameTypesByProvider(data);
      this.filter = [];
      this.filter.push("All");
      types.map((obj) => {
        let capitalized = obj.type.replace(/^./, obj.type[0].toUpperCase());
        this.filter.push(capitalized);
      });
    },
  },
};
</script>

<style>
.v-text-field__details {
  display: none !important;
}
.theme--dark.v-list {
  background-color: #031b41 !important;
}
</style>
